import { indexMappingsToString } from 'symbols/indexMappings/indexMappingsUtils';
import { useSelectIndexMappingsUserPreferenceWithoutDefaulting } from 'symbols/indexMappings/hooks';

export function useIndexMappingsDisplayText() {
    const userPrefMappings =
        useSelectIndexMappingsUserPreferenceWithoutDefaulting();

    return userPrefMappings
        ? indexMappingsToString(userPrefMappings)
        : 'Fetching...';
}
